import { useMutation } from '@tanstack/react-query';
import { Trans, useTranslation } from 'react-i18next';
import { z } from 'zod';
import { toast } from 'sonner';
import { newsletterSubscribeAPI } from 'src/api/newsletterSubscribeAPI';
import { ToastStyled } from 'src/components';

type Props = {
  setEmail: (value: React.SetStateAction<string>) => void;
  inputRef: React.RefObject<HTMLInputElement>;
};

export const useNewsletterSubscribe = ({ setEmail, inputRef }: Props) => {
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async (email: string) => {
      if (!z.string().email().safeParse(email).success) {
        throw new Error('Invalid email');
      }

      await newsletterSubscribeAPI(email);
    },
    onSuccess: () => {
      setEmail('');

      toast.custom((toastBlock) => (
        <ToastStyled
          variant='success'
          handleClose={() => toast.dismiss(toastBlock)}
        >
          <Trans
            i18nKey={t('footer.subscription_success')}
            components={[<br />, <strong />]}
          />
        </ToastStyled>
      ));
    },
    onError: () => {
      toast.custom((toastBlock) => (
        <ToastStyled
          variant='error'
          handleClick={() => {
            inputRef.current?.focus();
          }}
          handleClose={() => toast.dismiss(toastBlock)}
        >
          {t('common.something_went_wrong')}
        </ToastStyled>
      ));
    },
  });
};
